/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Modal from 'bootstrap/js/dist/modal';

/*------------------------------------*\
    SHARE
\*------------------------------------*/
class Share {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.url = self.elem.getAttribute('data-share-url');
        self.shareButton = self.elem.querySelector('[data-share-button]');
        self.modal = new Modal(document.querySelector('[data-share-modal]'));
    }

    init() {
        let self = this;

        self.shareButton.addEventListener('click', event => {
            if (navigator.share) {
                navigator.share({
                    title: document.title,
                    url: self.url
                }).then(() => {
                    // success
                }).catch(console.error);
            } else {
                // fallback
                self.modal.show();
            }
        });
    }
}

export default Share;
